import { useCallback, useEffect } from 'react';
import { useAreFeatureFlagsReady } from '../../feature-flags/hooks/use-are-feature-flags-ready';
import { useUserSettingsReady } from '../../hooks/use-user-setting';
import { useLocale } from '../hooks';
import { Development } from './locale-codes';
import { useUserSettingLocale } from './use-user-setting-locale';

export const useUserSettingLocaleSync = () => {
  const { userSettingLocale, setUserSettingLocale } = useUserSettingLocale();
  const { locale } = useLocale();

  const userSettingsReady = useUserSettingsReady();
  const featureFlagsReady = useAreFeatureFlagsReady();

  const setUserSettingLocaleWithDelayed = useCallback(
    (newLocale) => {
      // This is a purely defensive function. If we turn a feature flag off, we could send
      // thousands of requests at a single moment. While we don't anticipate this would cause problems
      // we'd rather ensure it doesn't cause problems by staggering when the API calls are made.
      // It's acceptable for there to be a delay here because we opt to display the cached value over
      // the user setting;
      const getSaveDelay = () => {
        const MAX_DELAY = 5000; // 5 second maximum delay
        return Math.floor(Math.random() * MAX_DELAY);
      };

      setTimeout(() => {
        setUserSettingLocale(newLocale);
      }, getSaveDelay());
    },
    [setUserSettingLocale],
  );

  useEffect(() => {
    const stateNotReady = !userSettingsReady || !featureFlagsReady;
    const developmentLocaleSelect = locale === Development;

    if (stateNotReady || developmentLocaleSelect) {
      return;
    }

    if (userSettingLocale !== locale) {
      setUserSettingLocaleWithDelayed(locale);
    }
  }, [userSettingsReady, featureFlagsReady, userSettingLocale, setUserSettingLocaleWithDelayed, locale]);
};
